/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Newsletter_DescriptionInputs */

const en_directory_resources_newsletter_description = /** @type {(inputs: Directory_Resources_Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive a concise roundup of launches, useful discoveries, and directory signals.`)
};

const zh_directory_resources_newsletter_description = /** @type {(inputs: Directory_Resources_Newsletter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接收简洁的新品发布、实用发现和目录信号汇总。`)
};

/**
* | output |
* | --- |
* | "Receive a concise roundup of launches, useful discoveries, and directory signals." |
*
* @param {Directory_Resources_Newsletter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_newsletter_description = /** @type {((inputs?: Directory_Resources_Newsletter_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Newsletter_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_newsletter_description(inputs)
	return zh_directory_resources_newsletter_description(inputs)
});
export { directory_resources_newsletter_description as "directory.resources.newsletter.description" }